export const TABLE_COLUMN_MAPPINGS = new Map<string, string>([
  ['Fund name', 'fundName'],
  ['Symbol', 'symbol'],
  ['Since Inception', 'sinceInceptionRtn'],
  ['1 Yr', 'oneyear'],
  ['3 Yr', 'threeyear'],
  ['5 Yr', 'fiveyear'],
  ['10 Yr', 'tenyear'],
  ['ytdReturns', 'ytdReturns'],
  ['SEC Yield', 'secYield.yieldPct'],
  ['Expense Ratio', 'expenseRatio'],
  ['Inception Date', 'sinceInceptionRtnDate'],
])
